import React from "react";
import { Card, CardContent, CircularProgress, Typography } from "@mui/material";

export default function TelemetryLoading() {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 4,
        border: "1px solid #e2e8f0",
        p: 6,
        textAlign: "center",
      }}
    >
      <CircularProgress />
      <Typography sx={{ mt: 2, color: "#64748b", fontWeight: 700 }}>
        Loading live telemetry...
      </Typography>
    </Card>
  );
}